import React from 'react';

const AddManualSighting = () => {
  return <div>AddManualSighting</div>;
};

export default AddManualSighting;
